<h2 mat-dialog-title>Submit Research Job</h2>
<mat-dialog-content>
  <mat-form-field class="full-width" color="accent">
    <textarea matInput [(ngModel)]="userPrompt" rows="4" placeholder="Enter your prompt..."></textarea>
  </mat-form-field>
  <p>{{ data.filteredData.length }} Documents</p>
  <mat-list class="document-list">
    <mat-list-item *ngFor="let doc of data.filteredData" class="document-list-item">
      <div>
        <p matLine>{{ doc.company }} | {{ doc.year }} | {{ doc.title }}</p>

        <p matLine class="document-details">{{ doc.Description }}</p>
      </div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button (click)="submitJob()">Submit</button>
</mat-dialog-actions>
